/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_ArrivalInputs */

const en_rental_arrival = /** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrival`)
};

const es_rental_arrival = /** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llegada`)
};

const fr_rental_arrival = /** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrivée`)
};

const de_rental_arrival = /** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankunft`)
};

const id_rental_arrival = /** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedatangan`)
};

/** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */
const ja_rental_arrival = en_rental_arrival;

/** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */
const zh_rental_arrival = en_rental_arrival;

/** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */
const ar_rental_arrival = en_rental_arrival;

/** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */
const it_rental_arrival = en_rental_arrival;

/** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */
const ru_rental_arrival = en_rental_arrival;

/** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */
const pt_rental_arrival = en_rental_arrival;

/** @type {(inputs: Rental_ArrivalInputs) => LocalizedString} */
const ko_rental_arrival = en_rental_arrival;

/**
* | output |
* | --- |
* | "Arrival" |
*
* @param {Rental_ArrivalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_arrival = /** @type {((inputs?: Rental_ArrivalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_ArrivalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_arrival(inputs)
	if (locale === "es") return es_rental_arrival(inputs)
	if (locale === "fr") return fr_rental_arrival(inputs)
	if (locale === "de") return de_rental_arrival(inputs)
	if (locale === "ja") return ja_rental_arrival(inputs)
	if (locale === "zh") return zh_rental_arrival(inputs)
	if (locale === "ar") return ar_rental_arrival(inputs)
	if (locale === "id") return id_rental_arrival(inputs)
	if (locale === "it") return it_rental_arrival(inputs)
	if (locale === "ru") return ru_rental_arrival(inputs)
	if (locale === "pt") return pt_rental_arrival(inputs)
	return ko_rental_arrival(inputs)
});